import React from "react";

interface NavbarProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

export const Navbar: React.FC<NavbarProps> = ({
  children,
  className = "",
  ...props
}) => {
  return (
    <nav
      className={`block w-full max-w-full px-4 py-2 text-blue-gray-900 bg-white shadow-md bg-opacity-80 backdrop-blur-2xl backdrop-saturate-200 ${className}`}
      {...props}
    >
      {children}
    </nav>
  );
};